import { render } from "./FormQuestionText.vue?vue&type=template&id=31e0ac6d&scoped=true&ts=true"
import script from "./FormQuestionText.vue?vue&type=script&lang=ts"
export * from "./FormQuestionText.vue?vue&type=script&lang=ts"

import "./FormQuestionText.vue?vue&type=style&index=0&id=31e0ac6d&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e0ac6d"]])

export default __exports__